var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VideoCollectionImplementationDataProvider", {
    attrs: { video: _vm.video, "data-ui-section": "collection-drawer" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var implementationData = ref.data
          var isImplementationLoading = ref.isLoading
          return [
            isImplementationLoading
              ? _c(_vm.LoadingSlotComponent, { tag: "component" })
              : implementationData
              ? _c("VideoCollectionInfoDataProvider", {
                  attrs: {
                    "video-collection-implementation-data": implementationData
                  },
                  on: {
                    update: function($event) {
                      return _vm.handleVideoCollectionInfoUpdated(
                        implementationData,
                        $event
                      )
                    }
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(ref) {
                          var videoCollectionInfo = ref.data
                          var isVideoCollectionInfoLoading = ref.isLoading
                          return [
                            isVideoCollectionInfoLoading
                              ? _c(_vm.LoadingSlotComponent, {
                                  tag: "component"
                                })
                              : videoCollectionInfo
                              ? _c("div", [
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showSidePanel,
                                          expression: "showSidePanel"
                                        }
                                      ],
                                      staticClass: "video-collection-drawer"
                                    },
                                    [
                                      _c("VideoCollectionInfoContainer", {
                                        staticClass:
                                          "video-collection-drawer__col main",
                                        attrs: {
                                          "video-collection-info": videoCollectionInfo,
                                          "video-collection-implementation-data": implementationData
                                        },
                                        on: {
                                          "toggle-side": _vm.toggleSidePanel
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("VideoCollectionVideoListContainer", {
                                        staticClass:
                                          "video-collection-drawer__col aside",
                                        attrs: {
                                          video: _vm.video,
                                          "video-collection-info": videoCollectionInfo,
                                          "video-collection-implementation-data": implementationData
                                        },
                                        on: {
                                          "select-new-video":
                                            _vm.handleNewVideoSelected
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }